import { render, staticRenderFns } from "./processRisk.vue?vue&type=template&id=711e4a83&scoped=true"
import script from "./processRisk.vue?vue&type=script&lang=js"
export * from "./processRisk.vue?vue&type=script&lang=js"
import style0 from "./processRisk.vue?vue&type=style&index=0&id=711e4a83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711e4a83",
  null
  
)

export default component.exports